<script lang="ts" setup>
import type { Study } from '~/utils/generated/graphql'

const user = useFirebaseUser()
defineProps<{
  study: Study
  index: number
}>()
</script>

<template>
  <div>
    <h3 class="mt-8 mb-1 font-serif">
      {{ study.session?.title }}
    </h3>
    <h5 class="font-serif">
      {{ $t('dayN', { n: index + 1 }) }}
    </h5>
    <StudySignInPromo
      v-if="!user || user.isAnonymous"
      :study="study"
      :index="index"
    />
    <!-- eslint-disable vue/no-v-html -->
    <div v-html="study.session?.description" />
    <!-- eslint-enable -->
    <ContentComponents
      :item="study"
      :components="study.session?.components || []"
    />
  </div>
</template>
